import React from 'react';
import { ClipLoader } from 'react-spinners'; 
import LogoVideo from "../assets/Logo.mp4";

const Loading = () => {
  return (
    <div className='flex flex-col justify-center items-center h-screen relative bg-black/40'>
      {/* Video Container */}
      <div className="relative flex justify-center items-center mb-6">
        <div className="rounded-full overflow-hidden w-20 h-20 md:w-32 md:h-32">
          <video
            src={LogoVideo}
            autoPlay
            muted
            playsInline
            className='w-full h-full object-cover object-center'
          />
        </div>

        {/* Spinner Container */}
        <div className="absolute inset-0 flex justify-center items-center">
          <ClipLoader color={"#B809C3"} loading={true} size={100} />
        </div>
      </div>
    </div>
  );
}

export default Loading;
